/**
 * Shared page-level style constants for styled-components.
 *
 * Three deliberate conventions are exported:
 *   - pageTitle           — orange 40px (matches legacy Gotham light header)
 *   - workspaceTitle      — neutral 32px for task-workspace / brief headers
 *   - orgSubsectionTitle  — compact 24px for org-level subsection headers
 *
 * Usage:
 *   import { pageTitle } from '../../styles/pageStyles';
 *   const PageTitle = styled.h1`${pageTitle} margin: 0 0 8px;`;
 */
import { css } from 'styled-components';

/* -- Page title — matches legacy Gotham light 40px orange header -- */
export const pageTitle = css`
  font-family: var(--font-family-primary);
  font-size: 40px;
  font-weight: 300;
  color: #FF8C23;
  letter-spacing: -0.05em;
  line-height: 1;
`;

/*
 * Workspace title — used on pages where the h1 is the "workspace frame"
 * (e.g. the Tasks dashboard greeting, the Create Story Brief form).
 * Matches prod's rendering on the legacy /tasks page (32 / 400 / line-height 34).
 */
export const workspaceTitle = css`
  font-family: var(--font-family-primary);
  font-size: 32px;
  font-weight: 400;
  color: #333;
  line-height: 34px;
`;

/*
 * Organisation subsection title — compact header used under the
 * organisation settings nav (e.g. /organizations/:id/portals).
 */
export const orgSubsectionTitle = css`
  font-family: var(--font-family-primary);
  font-size: 24px;
  font-weight: 600;
  color: #333;
  line-height: 32px;
`;
